import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { CategorizationRow } from "../categorizationTableMeta";

export const CategoryPathCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CategorizationRow, string>) => (
        <ViewTableCell>
            <BreakableText text={row.original.categoryPath} showTooltip />
        </ViewTableCell>
    ),
);
CategoryPathCell.displayName = "CategoryPathCell";
